import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'jsonString'
})
export class JsonStringPipe implements PipeTransform {

    transform(value: string, args: string): string {
        if (!value) return value;

        const jsonObject = JSON.parse(value);

        return jsonObject[args];
    }
}